const PAGE_CUSTOM = 'PageCustom'
const PAGE_OUTPUT_TABS = 'PageOutputTabs'
const PAGE_OUTPUT_KPIS_TABS = 'PageOutputKpisTabs'
const PAGE_OUTPUT_SIDEBAR = 'PageOutputSidebar'
const PAGE_OUTPUT_KPIS_TABLES = 'PageOutputKpisTables'
const PAGE_OUTPUT_CHARTS_TABLE = 'PageOutputChartsTable'
const PAGE_OUTPUT_KPIS_GANTT = 'PageOutputKpisGantt'

export const TemplateTypes = {
  PAGE_CUSTOM,
  PAGE_OUTPUT_TABS,
  PAGE_OUTPUT_KPIS_TABS,
  PAGE_OUTPUT_SIDEBAR,
  PAGE_OUTPUT_KPIS_TABLES,
  PAGE_OUTPUT_CHARTS_TABLE,
  PAGE_OUTPUT_KPIS_GANTT
}
